/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import { NavLink } from 'react-router-dom'
import { Translate } from 'react-localize-alias'

import successImg from '../../../../../assets/images/Hand/success.png'
import failureImg from '../../../../../assets/images/Hand/failure.png'
import timeoutImg from '../../../../../assets/images/Hand/timeout.png'
import notFoundImg from '../../../../../assets/images/Hand/notFound.png'

import styles from './ProcessStatus.module.scss'
import { ProcessStatusType } from '../../../enum'
import { Title } from '../../../UIKit/Title'
import { Button } from '../../../UIKit/Button'

const statuses = {
  [ProcessStatusType.SUCCESS]: {
    img: successImg,
    title: 'process.success',
    description: 'process.success.thanks',
  },
  [ProcessStatusType.FAILURE]: {
    img: failureImg,
    title: 'process.error',
    description: 'process.check.data',
  },
  [ProcessStatusType.TIMEOUT]: {
    img: timeoutImg,
    title: 'process.error',
    description: 'process.timeout',
  },
  [ProcessStatusType.IN_DEVELOPMENT]: {
    img: timeoutImg,
    title: 'development.title',
    description: 'development.description',
  },
  [ProcessStatusType.NOT_FOUND]: {
    img: notFoundImg,
    title: 'process.not.found',
    description: 'process.page.does.not.exist',
  },
}

export interface ProcessStatusProps {
  variant: ProcessStatusType
}

export const ProcessStatus = ({
  variant,
}: ProcessStatusProps) => {
  return (
    <div className={styles.root}>
      <div className={styles.wrapper}>
        <img className={styles.image} src={statuses[variant].img} />

        <div className={styles.text}>
          <Title h={1}>
            <Translate id={statuses[variant].title} />
          </Title>
          <div className={styles.description}>
            <Translate id={statuses[variant].description} />
          </div>
        </div>

        {variant !== ProcessStatusType.FAILURE &&
        <NavLink to="/">
          <Button fullWidth>
            <Translate id="close" />
          </Button>
        </NavLink>
        }
      </div>
    </div>
  )
}
